import React from 'react';
import { useTranslation } from 'react-i18next';
import HeadTittle from '../../../../../components/HeadTittle';
import routes from '../../../../../Routes/routes';
import StepperTabs from '../../../../../components/StepperTabs/StepperTabs';
import StepTab from '../../../../../components/StepperTabs/StepTab';
import { STEPS_CREATE_NEW_ROLE } from '../Model/AllowedModules';
import { ButtonNextStep, ButtonPrevStep } from '../../../../../components/buttons/ButtonNavigation';
import AssignedEmployees from './AssignedEmployees';
import Summary from './Summary';
import SetUpPrivileges from './SetUpPrivileges';
import CreateNewRoleApp from '../Functionality/CreateNewRoleApp';
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */
const CreateNewRole = () => {
    const { t } = useTranslation();
    const {
        handleCreateRole,
        activeStep,
        steps,
        setActiveStep,
        handleStepChange,
        handleValidateSteps,
        selected,
        setSelected,
        web,
        mobile,
        emptyFields,
        selectedPermissions,
        setSelectedPermissions,
        roleListData,
        clearField,
        id,
        handleClearEmployees,
        readOnly,
        item,
        handleChange,
        emptyPrivilege
    } = CreateNewRoleApp();

    return (
        <>
            <HeadTittle name={t('create')} onBack={routes.roles.list}/>
            <div className='create_new_role'>
                <div className='row'>
                    <StepperTabs
                        id={null}
                        disabled={false}
                        steps={steps}
                        activeStep={activeStep}
                        isStepOptional={() => {}}
                        setActiveStep={setActiveStep}
                        handleStepChange={handleStepChange}
                    >
                        <StepTab index={STEPS_CREATE_NEW_ROLE.SET_UP_PRIVILEGES} activeStep={activeStep} normalHeight>
                            <>
                                <SetUpPrivileges
                                    web={web}
                                    mobile={mobile}
                                    item={item}
                                    handleChange={handleChange}
                                    emptyFields={emptyFields}
                                    selectedPermissions={selectedPermissions}
                                    setSelectedPermissions={setSelectedPermissions}
                                    clearField={clearField}
                                    id={id}
                                    readOnly={readOnly}
                                    emptyPrivilege={emptyPrivilege}
                                />
                                <div className='col-sm-12 col-xxl-6 col-lg-6 offset-xxl-6 offset-lg-6 mb-60px d-flex justify-content-end mt-3'>
                                    <ButtonNextStep
                                        id='btn_cnr_next_set_up_privileges'
                                        text='next'
                                        click={() => {
                                            if (handleValidateSteps(activeStep)) {
                                                setActiveStep((prevStep) => prevStep + 1);
                                            }
                                        }}
                                    />
                                </div>
                            </>
                        </StepTab>

                        <StepTab index={STEPS_CREATE_NEW_ROLE.ASSIGN_EMPLOYEES} activeStep={activeStep} normalHeight>
                            <>
                                {activeStep === STEPS_CREATE_NEW_ROLE.ASSIGN_EMPLOYEES && (
                                    <AssignedEmployees
                                        selected={selected}
                                        setSelected={setSelected}
                                        id={id}
                                        handleClearEmployees={handleClearEmployees}
                                    />
                                )}
                                <div className='col-12 d-flex justify-content-between mt-3 mb-60px mt-3'>
                                    <ButtonPrevStep
                                        id='btn_cnr_back_assing_employees'
                                        text='back'
                                        click={() => setActiveStep((prevStep) => prevStep - 1)}
                                    />
                                    <ButtonNextStep
                                        id='btn_cnr_next_assing_employees'
                                        text='next'
                                        disabled={activeStep === steps.length - 1}
                                        click={() => {
                                            if (handleValidateSteps(activeStep, true)) {
                                                setActiveStep((prevStep) => prevStep + 1);
                                            }
                                        }}
                                    />
                                </div>
                            </>
                        </StepTab>

                        <StepTab index={STEPS_CREATE_NEW_ROLE.SUMMARY} activeStep={activeStep} normalHeight>
                            <Summary
                                selected={selected}
                                selectedPermissions={selectedPermissions}
                                roleName={item?.roleName}
                                t={t}
                                roleListData={roleListData}
                            />
                            <div className='d-flex justify-content-between px-0 mb-2 mt-3'>
                                <ButtonPrevStep
                                    id='btn_cnr_back_summary'
                                    text='back'
                                    click={() => setActiveStep((prevStep) => prevStep - 1)}
                                />
                                <ButtonNextStep
                                    id='btn_cnr_create'
                                    text='create'
                                    click={() => {
                                        handleCreateRole();
                                    }}
                                />
                            </div>
                        </StepTab>
                    </StepperTabs>
                </div>
            </div>
        </>
    );
};

export default CreateNewRole;
